import { useLocation } from 'react-router-dom';

import { LoginStateFields } from 'common/enum/login-state-fields.enum';

export const useLoginPageState = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const tenantName = urlParams.get(LoginStateFields.TENANT_NAME);
  const isRootLogin = urlParams.get(LoginStateFields.IS_ROOT) === 'true';

  const selectedState = {
    tenantName,
    isRootLogin,
  };

  return { selectedState };
};
